import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "flight-details" }
const _hoisted_2 = { class: "flight-details__flight-time" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flight-details__stops" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "flight-details__airline"
}

import { computed } from 'vue';
import { pluralize } from '@/js/utils/utils';
import { formatFlightDuration } from '@/js/utils/dateTimeUtils';

type Props = {
	departureTime?: string;
	arrivalTime?: string;
	airline?: string;
	numberOfStops?: number;
	duration?: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'FlightDetails',
  props: {
    departureTime: {},
    arrivalTime: {},
    airline: {},
    numberOfStops: {},
    duration: {}
  },
  setup(__props: any) {


let totalFlightTime = null;
const displayDepartureTime = computed(() => {
	return __props.departureTime || '--';
});

const displayArrivalTime = computed(() => {
	return __props.arrivalTime || '--';
});

const stops = computed(() => {
	if (__props.numberOfStops === 0) {
		return 'Direktflug';
	}
	if (!__props.numberOfStops) {
		return ' ';
	}
	return pluralize(__props.numberOfStops, 'Stop', 'Stops');
});
if (__props.duration) {
	totalFlightTime = formatFlightDuration(__props.duration, true);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(displayDepartureTime.value === '--' ? 'span' : 'time'), { datetime: displayDepartureTime.value }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(displayDepartureTime.value), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["datetime"])),
      _cache[0] || (_cache[0] = _createElementVNode("span", null, " – ", -1 /* HOISTED */)),
      (_openBlock(), _createBlock(_resolveDynamicComponent(displayArrivalTime.value === '--' ? 'span' : 'time'), { datetime: displayArrivalTime.value }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(displayArrivalTime.value), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["datetime"])),
      (!_ctx.departureTime && !_ctx.arrivalTime)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Uhr"))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (stops.value !== ' ')
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(stops.value) + " •", 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _cache[1] || (_cache[1] = _createTextVNode()),
      (_unref(totalFlightTime))
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(totalFlightTime)), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.airline)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.airline), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})